import { Component, ChangeDetectionStrategy, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Textbox question component.
 * Displays and configures a text input question.
 * Uses Angular signals inherited from BaseQuestionComponent.
 */
@Component({
  selector: 'app-textbox-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './textbox-question.component.html',
  styleUrl: './textbox-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextboxQuestionComponent extends BaseQuestionComponent {
  placeholder: string = '';
  maxLength: number | null = null;

  constructor() {
    super();
    // Initialize values from question input when it changes
    effect(() => {
      const q = this.question();
      // Initialize placeholder from question
      if (q.placeholder) {
        this.placeholder = q.placeholder;
      }
      // Initialize maxLength from validators.maxLength
      if (q.validators?.['maxLength']) {
        const maxLengthValue = parseInt(q.validators['maxLength'], 10);
        if (!isNaN(maxLengthValue)) {
          this.maxLength = maxLengthValue;
        }
      }
    });
  }

  onLabelChange(value: string): void {
    this.updateLabel(value);
  }

  onPlaceholderChange(value: string): void {
    this.placeholder = value;
    this.emitConfigChange({ placeholder: this.placeholder } as any);
  }

  onMaxLengthChange(value: string): void {
    const numValue = value === '' ? null : parseInt(value, 10);
    this.maxLength = isNaN(numValue as any) ? null : numValue;
    // Update validators object with new maxLength value
    const currentValidators = this.question().validators || {};
    const updatedValidators = { ...currentValidators };
    if (this.maxLength !== null) {
      updatedValidators['maxLength'] = String(this.maxLength);
    } else {
      delete updatedValidators['maxLength'];
    }
    this.emitConfigChange({ validators: updatedValidators } as any);
  }

  onHelperTextChange(value: string): void {
    this.updateHelperText(value);
  }

  onAdditionalInfoChange(value: string): void {
    this.updateAdditionalInfo(value);
  }

  onRequiredToggle(): void {
    this.updateRequired(!this.question().isRequired);
  }
}

